import script from "./CGamesOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./CGamesOverview.vue?vue&type=script&setup=true&lang=ts"

import "./CGamesOverview.vue?vue&type=style&index=0&id=24627f2c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24627f2c"]])

export default __exports__